import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "@/pages/Home";
import HomeServicesHub from "@/pages/HomeServicesHub";
import TradePage from "@/pages/TradePage";
import TourismHub from "@/pages/TourismHub";
import TourismCategoryPage from "@/pages/TourismCategoryPage";
import CaseStudies from "@/pages/CaseStudies";
import Platforms from "@/pages/Platforms";
import SampleAds from "@/pages/SampleAds";
import PackagesFAQ from "@/pages/PackagesFAQ";
import AdminLeads from "@/pages/AdminLeads";
import MagazineAd from "@/pages/MagazineAd";
import ScrollToHash from "@/components/ScrollToHash";
import {
  MeetTheTeamProvider,
  MeetTheTeamFloatingPill,
} from "@/components/MeetTheTeam";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <MeetTheTeamProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home-services" element={<HomeServicesHub />} />
            <Route path="/home-services/:slug" element={<TradePage />} />
            <Route path="/tourism" element={<TourismHub />} />
            <Route path="/tourism/case-studies" element={<CaseStudies />} />
            <Route path="/tourism/:slug" element={<TourismCategoryPage />} />
            <Route path="/platforms" element={<Platforms />} />
            <Route path="/sample-ads" element={<SampleAds />} />
            <Route path="/packages/faq" element={<PackagesFAQ />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
            <Route path="/print/magazine-ad" element={<MagazineAd />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <MeetTheTeamFloatingPill />
        </MeetTheTeamProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
